module.exports = __webpack_public_path__ + "static/media/material-leather.51b31b95.svg";